var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-title"},[_c('h3',{staticClass:"title-content",class:{ 'small': _vm.size === 'small' }},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"boder-box"})])}
var staticRenderFns = []

export { render, staticRenderFns }